import { render, staticRenderFns } from "./sectionHeader.vue?vue&type=template&id=4d06dedd&scoped=true&"
import script from "./sectionHeader.vue?vue&type=script&lang=js&"
export * from "./sectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./sectionHeader.vue?vue&type=style&index=0&id=4d06dedd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06dedd",
  null
  
)

component.options.__file = "sectionHeader.vue"
export default component.exports